import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { mergeMap, delay } from 'rxjs/operators';
import { OnDemandPreloadService } from './on-demand-preload.service';

@Injectable({
  providedIn: 'root',
})
export class OnDemandPreloadStrategy implements PreloadingStrategy {
  private preloadOnDemand$: Observable<string[]>;

  constructor(private preloadOnDemandService: OnDemandPreloadService) {
    this.preloadOnDemand$ = this.preloadOnDemandService.subject;
  }

  preload(route: Route, load: () => Observable<any>): Observable<any> {
    return this.preloadOnDemand$.pipe(
      mergeMap((preloadPath) => {
        const shouldPreload = preloadPath.indexOf(String(route.path)) >= 0;
        return shouldPreload ? of(load()).pipe(delay(1500)) : of(null);
      })
    );
  }
}
